<template>
  <div>
    <Proofing-Table :orderCode="orderCode" :disabled="disabled" />
  </div>
</template>

<script>
import ProofingTable from './components/table/index.vue'
export default {
  components: {
    ProofingTable,
  },
  props: {
    orderCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
